/**
 * activeFilters in the shape processActiveFilters expects — the Topics V2
 * scope vocabulary. Shared by the page (its sidebar controls emit these)
 * and by the components that narrow the page's scope further for their own
 * requests (the drilldown's lines, the row panel's annotations), so a node
 * or period filter is built one way everywhere.
 */
export const ALL_TIME_VALUE = "all_time";

export const periodFilter = (period) =>
  period && period.value !== ALL_TIME_VALUE && period.from && period.to
    ? { filterId: "datesThatMatter", target: { filterType: "datesThatMatterType", isAnno: true }, values: [period.from, period.to] }
    : null;

export const datasetFilter = (contentType) =>
  contentType
    ? { filterId: "topicsDataset", target: { filterType: "valuePathType", valuePath: "meta.contentType" }, values: [{ value: contentType }] }
    : null;

export const signalsFilter = (signalIds) =>
  signalIds?.length
    ? { filterId: "topicsSignals", target: { filterType: "tagType", tagType: "tags", isAnno: true }, values: signalIds.map((id) => ({ value: id })) }
    : null;

export const topicNodeFilter = (nodeId, topicClusteringLens) => ({
  filterId: "topicClusteringNodes",
  target: { filterType: "topicClusteringNodeType", topicClusteringLens, isAnno: true },
  values: [{ value: nodeId }],
});

// A surface's scope as the panels read it: the period, plus any narrowing
// filters (a signal category's signals), as processActiveFilters filters.
// `previousWindowFiltersFor` is the same scope with the period swapped for
// the previous calendar window — what the "vs last period" chips compare
// against (none for all time).
export const activeFiltersFor = (period, extraFilters = []) => [periodFilter(period), ...extraFilters].filter(Boolean);
export const previousWindowFiltersFor = (prevWindow, extraFilters = []) =>
  prevWindow ? activeFiltersFor({ value: "previous_window", from: prevWindow.from, to: prevWindow.to }, extraFilters) : null;

// The signal ids in one category, from the counts payload's signal meta —
// what a category-scoped request (a parked row's annotations) narrows to.
export const signalIdsInCategory = (signalMetaById, category) =>
  Object.values(signalMetaById || {})
    .filter((m) => m.category === category)
    .map((m) => String(m._id));
